import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';
import { Button, Drawer } from '@/ui';

export const StyledPageWrapper = styled.div`
  display: flex;
  flex-direction: column;

  &&& .ant-drawer-body {
    padding: 0;
  }
`;

export const StyledTabsWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: flex-end;
`;

export const StyledCreateButton = styled(Button)`
  &&& {
    max-width: 13rem;
    height: 2.125rem;
    border-radius: 2rem;
  }
`;

export const StyledDrawer = styled(Drawer)`
  &&& .ant-drawer-header {
    justify-content: space-between;
  }

  &&& .ant-drawer-body {
    padding: 0;
  }

  .ant-drawer-title {
    flex: initial;
  }
`;

export const StyledPageTitle = styled.div`
  ${pickThemeFontStyles('40', '48', 'SEMI_BOLD')};
  color: ${COLORS.DARK_PURPLE};
`;

export const StyledHeaderBlock = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 2rem;
`;

export const StyledContentBlock = styled.div`
  display: flex;
  width: 100%;
  padding: 2rem;
  flex-direction: column;
`;

export const StyledButton = styled(Button)`
  svg {
    margin-right: 0.5rem;
  }
`;

export const StyledPagination = styled.div`
  max-width: 50%;
`;
